
<script>
export default {
   props: {
      asset: {}
   }

}
</script>

<style lang="scss" scoped>
.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.player-container {
   position: absolute;
   z-index: 2;
   margin: auto;
   top: 0;
   bottom: 0;
   right: 0;
   left: 0;
   width:1000px;
   height: 1500px;
   overflow: hidden;
   background: black;

   color: white;
}

#jquery_jplayer_1,
#jquery_jplayer_3 {
   background: #000;
}

audio{
  width: 100%;
}

.header-container {
  padding-top: 15px;
  padding-left: 20px;
}

.header-title {
  font-size: 22px;
}

.audio-controls {
  position: relative;
}

.close-btn {
	position: absolute;
	right: 13px;
	top: 17px;
}

/**Player**/

#jp_container_1 img,
#jp_container_3 img {
  width: 15px;
  height: 15px;
}

.jp-play {
  background: white;
}

#play,
#pause {
  margin-right: 7px;
}

.button-container {
  display: flex;
  position: relative;
}

.jp-audio button {
  padding: 0;
  border: none;
  background: black;
}

.jp-audio {
  width: 100%;
  background: black;
  padding:0;
}

.jp-padding {
  padding: 20px;
}

.jp-type-single {
  display: flex;
  align-items: center;

  .progress {
     margin-bottom: 0px !important;
  }
}

.jp-ball {
  position: absolute;
  z-index: 999;
  border-radius: 30px;
  left: 0;
  width: 1em;
  height: 1em;
  margin: -0.2em 0px 0px -0.5em;
  width: 14px;
  height: 14px;

  width: 0.9333em;
  height: 0.9333em;
  margin: -0.175em 0px 0px -0.466em;
  background-color: #fff;
  padding: 0px;
  -webkit-transition: -webkit-transform 0.15s ease-in-out;
  transition: transform 0.15s ease-in-out;
}

.progress {
   padding: 3px 0;
   background: transparent;
}

.seek-wrapper {
  width: 600px;
  margin: 0 7px;
}

#seek_bar {
  height: 7px;
  background: gray;
  position:relative;
}

#play_bar {
  height: 7px;
  background: #2797d9;
}

#duration {
  font-size: 12px;
  margin-right: 25px;
}

#volume_icon {
  margin-right: 7px;
}

#volume_bar {
  height: 7px;
  width: 150px;
  background: gray;
  margin-right: 75px;
}

#volume_value {
  background: #2797d9;
  height: 7px;
}

#seek_bar,
#play_bar,
#volume_value,
#volume_bar {
  border-radius: 5px;
}

.close-btn-red {
  width: 33px !important;
  height: 33px !important;
  position: absolute;
  right: 7px;
}

/**Wave Animation **/

.wave-container {
  background:black;
   width: 300vw;
   height: 90%;
   /* position: fixed; */
   overflow: hidden;
   transform: translate3d(0, 0, 0);
 }
 
 .wave {
   opacity: 1;
   position: absolute;
   top: 60%;
   left: -28%;
   background: #999899;
   width: 100%;
   height: 300vw;
   transform-origin: 50% 49%;
   border-radius: 49%;
   -webkit-animation: drift 3000ms infinite linear;
   animation: drift 8000ms infinite linear;
   will-change: transform;
 }
 
 .wave.-two {
   animation: drift 9000ms infinite linear;
   opacity: 1;
   background: #8d3228;
   top: 60%;
   left: -32%;
 }
 
 .wave.-three {
   animation: drift 4000ms infinite linear;
   opacity: 1;
   background: #f99f1c;
   top: 60%;
   left: -36%;
   z-index: -2;
 }
 
 @keyframes drift {
   from {
     transform: rotate(0deg);
   }
   from {
     transform: rotate(360deg);
   }
 }

 /* Weblink specific */
 .link-wrapper {
    background: black;
    height: 100%;
    width: 100%;
    text-align: center;
    padding: 10px 20px;

    .header-container {
       padding: 10px 0;
       text-align: left;
    }

    iframe {
       width: 100%;
       height: 1400px;
    }
 }


 #audio #main_list {
   height: 0px;
   width: 0px;
 }

.player-container .carousel-btn-wrapper {
   position: absolute;
   top: 800px;
}

.player-container .prev-wrapper-aud {
   left: 7px;
}

.player-container .next-wrapper-aud {
   right: 7px;
}
 
.player-container .jp-jplayer {
   margin: 0 auto;
 }

.video-inner-wrapper, .audio-inner-wrapper {
  width: 100%;
  position: absolute;
}

.audio-inner-wrapper {
  bottom: 1%;
}

.video-inner-wrapper {
  /* width: 100%; */
  /* padding-top: 40px; */
  padding-top: 48px;
  top: 0px;
  /* position: absolute; */
}

#video #main_list {
  height: 100%;
}

#video .thumb-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}

#main_list {
   width: 810px;
   margin: 0 auto;
}

.carousel-btns img {
   width: 70px;
   height: 61px;
}

.slick-track {
   display: flex;
   align-items: center;
}

.header-title {
   padding-left: 5px;
}


</style>
